<template>
    <div class="wrap-content customer-section">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-12">
                    <h2>Tracker</h2>
                </div>
                <div class="col-md-12 filter-all-customers">
                    <div class="row">
                        <div class="col-md-4">
                            <b-form-group>
                                <b-form-radio-group v-model="query.customerVerificationStatus" :options="filterList" buttons
                                                    button-variant="outline-primary" @change="apply"></b-form-radio-group>
                            </b-form-group>
                        </div>


                        <div class="col-md-8">
                            <div class="row">
                                <div class="col-md-8">
                                    <base-search placeholder="Search" @keyword="getKeyword"></base-search>
                                </div>
                                <div :class="{
                                    'col-md-2': hasScopes(
                                        'export-customer-profile'
                                    ),
                                    'col-md-2': !hasScopes(
                                        'export-customer-profile'
                                    ),
                                }">
                                    <b-form-group>
                                        <button class="btn btn-primary" type="submit" :class="
                                            loading && showPageLoader
                                                ? 'disabled'
                                                : ''
                                        " @click="apply">
                                            <span class="btn-text">Apply</span>
                                            <span class="loader"></span>
                                        </button>
                                    </b-form-group>
                                </div>
                                <div class="col-md-1">
                                    <b-form-group>
                                        <b-button
                                                type="button"
                                                variant="secondary"
                                                class="secondary-add-btn"
                                                @click="exportRecords"
                                        >
                                            <span class="btn-text">EXPORT</span>
                                        </b-button>
                                    </b-form-group>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div :class="[
            'table-section',
            'table-min-width',
            {
                'overflow-hidden': !data.length && !showPageLoader,
            },
        ]">
            <b-table :items="data" :fields="fields" no-local-sorting @sort-changed="sortingChanged">
                <template slot="pictureURL" slot-scope="data">
                    <div class="profile-area">
                        <router-link :to="{
                            name: 'customer-information',
                            params: {
                                id: data.item._id,
                            },
                        }">
                            <div v-if="data.item.pictureURL!=null && data.item.pictureURL!='customers/no-preview.png'"
                                 class="profile-pic"
                                 v-authenticated-image="data.item.pictureURL"
                                 alt="Profile Image">

                            </div>
                            <!--Added by SAIF--><div v-else class="profile-pic"
                                                     v-authenticated-image="'users/blank-profile-pic.png'"
                                                     alt="Profile Image"> <!--Added by SAIF-->
                        </div>

                        </router-link>
                    </div>
                </template>

                <template slot="idenfoId" slot-scope="data">
                    <div class="customer-link">
                        <router-link :to="{
                            name: data.item.type=='company' ?'company-information' :'customer-information',
                            params: {
                                id: data.item._id,
                            },
                        }">
                            {{ data.item.idenfoId }}
                        </router-link>
                    </div>
                </template>

                <template slot="fullName" slot-scope="data">
                    <div class="action-flex">
                        <router-link :to="{
                            name: data.item.type=='company' ?'company-information' :'customer-information',
                            params: {
                                id: data.item._id,
                            },
                        }">
                            <span>
                                {{ data.item.fullName | titleCase }}
                            </span>
                        </router-link>
                    </div>
                </template>
                <!-- Join Date -->
                <template slot="createdAt" slot-scope="data">
                    {{ data.item.createdAt | moment('MMM D, YYYY h:mm a') }}
                </template>

                <template slot="idenfoVerificationStatus" slot-scope="data">
                    <base-status :status-type="data.item.idenfoVerificationStatus?data.item.idenfoVerificationStatus:'pending'"></base-status>
                    <br>
                    {{ data.item.customerVerificationStatus.idenfoVerificationDate | moment('MMM D, YYYY h:mm a') }}

                </template>

                <template slot="nadra" slot-scope="data">
                    <b style="border-bottom: 1px solid;line-height: 30px;">{{getValue(data.item.customerVerificationStatus.nadra,data.item.customerVerificationStatus.idenfoVerificationDate)}}</b>
                    <br>
                    {{ data.item.customerVerificationStatus.idVerificationDate | moment('MMM D, YYYY h:mm a') }}
                </template>
                <!--<template slot="license" slot-scope="data">-->
                    <!--<b style="border-bottom: 1px solid;line-height: 30px;">{{getValue(data.item.customerVerificationStatus.license,data.item.customerVerificationStatus.idenfoVerificationDate)}}</b>-->
                    <!--<br>-->
                    <!--{{ data.item.customerVerificationStatus.licenseVerificationDate | moment('MMM D, YYYY h:mm a') }}-->
                <!--</template>-->
                <template slot="degree" slot-scope="data">
                    <b style="border-bottom: 1px solid;line-height: 30px;">{{getValue(data.item.customerVerificationStatus.degree,data.item.customerVerificationStatus.idenfoVerificationDate)}}</b>
                    <br>
                    {{ data.item.customerVerificationStatus.degreeVerificationDate | moment('MMM D, YYYY h:mm a') }}
                </template>
                <template slot="employment" slot-scope="data">
                    <b style="border-bottom: 1px solid;line-height: 30px;">{{getValue(data.item.customerVerificationStatus.employment,data.item.customerVerificationStatus.idenfoVerificationDate)}}</b>
                    <br>
                    {{ data.item.customerVerificationStatus.employmentVerificationDate | moment('MMM D, YYYY h:mm a') }}
                </template>
                <template slot="criminalRecordVerification" slot-scope="data">
                    <b style="border-bottom: 1px solid;line-height: 30px;">{{getValue(data.item.customerVerificationStatus.criminalRecordVerification,data.item.customerVerificationStatus.idenfoVerificationDate)}}</b>
                    <br>
                    {{ data.item.customerVerificationStatus.criminalRecordVerificationDate | moment('MMM D, YYYY h:mm a') }}
                </template>
                <template slot="aging" slot-scope="data">
                    <b style="line-height: 30px;">{{getAging(data.item)}}</b>
                </template>


            </b-table>
            <!-- When data is loading -->
            <base-table-spinner v-if="!data.length && showPageLoader"></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found v-if="!data.length && !showPageLoader"></base-no-record-found>
        </div>

        <base-records path="users/applications" :query="query" :reset="reset" :show-pagination="true"></base-records>

    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import request from '@/utils/request'

    export default {
        /*
        |--------------------------------------------------------------------------
        | Component > components
        |--------------------------------------------------------------------------
        */
        components: {}, // End of Component > components

        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        props: {}, // End of Component > props

        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
        data() {
            return {
                isEditProfile:false,
                fields: {
                    pictureURL: {
                        label: '',
                        tdClass: 'profile-absolute',
                        tdAttr: {
                            dataname: '',
                        },
                    },
                    idenfoId: {
                        label: 'Idenfo Id',
                        sortable: true,
                        tdAttr: {
                            dataname: 'Customer',
                        },
                    },
                    fullName: {
                        label: 'NAME',
                        sortable: true,
                        tdAttr: {
                            dataname: 'Full Name',
                        },
                        tdClass: 'email-truncate',
                    },

                    createdAt: {
                        label: 'REGISTRATION DATE',
                        sortable: true,
                        tdAttr: {
                            dataname: 'createdAt',
                        },
                    },
                    aging: {
                        label: 'TAT',
                        sortable: true,
                        tdAttr: {
                            dataname: 'aging',
                        },
                    },
                    idenfoVerificationStatus: {
                        key:'idenfoVerificationStatus',
                        label: 'Idenfo Verification Status',
                        sortable: true,
                        tdClass: 'text-center status-absolute-pos',
                        thClass: 'text-center',
                        tdAttr: {
                            dataname: 'idenfoVerificationStatus',
                        },
                    },
                    nadra: {
                        label: 'ID Document Verification',
                        sortable: true,
                        tdAttr: {
                            dataname: 'nadra',
                        },
                    },
                    // license: {
                    //     label: 'License Verification',
                    //     sortable: true,
                    //     tdAttr: {
                    //         dataname: 'license',
                    //     },
                    // },
                    degree: {
                        label: 'Degree Verification',
                        sortable: true,
                        tdAttr: {
                            dataname: 'degree',
                        },
                    },
                    employment: {
                        label: 'Employment Verification',
                        sortable: true,
                        tdAttr: {
                            dataname: 'employment',
                        },
                    },
                    criminalRecordVerification: {
                        label: 'Criminal Record Verification',
                        sortable: true,
                        tdAttr: {
                            dataname: 'criminalRecordVerification',
                        },
                    },

                },
                filterList: [
                    { text: 'All', value: null },
                    { text: 'Pending', value: 'pending' },
                    { text: 'Completed', value: 'completed' },
                    { text: 'High Risk', value: 'high' },
                ],

                query: {
                    startAt: 1,
                    keyword: '',
                    perPage: 10,
                    status: null,
                    sortBy: 'idenfoId',
                    sortOrder: 'desc',
                    type:null,
                    profileType : null,
                    customerVerificationStatus:null
                },
                reset: new Date().getTime(),
                id: null,
            }
        }, // End of Component > data

        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        computed: {
            ...mapGetters([
                'data',
                'showPageLoader',
                'loading',
                'dataSegmentId',
                'hasScopes',
                'user'
            ]),
        }, // End of Component > computed
        /*
        |--------------------------------------------------------------------------
        | Component > watch
        |--------------------------------------------------------------------------
        */
        watch: {}, // End of Component > methods

        /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
        mounted() {

            var permissions = this.$store.state.authentication.scopes
            this.isEditProfile = permissions.includes("edit-profile")
            localStorage.setItem('goBackUrl', this.$route.name)
            let queryData = JSON.parse(localStorage.getItem('queryData'))
            if (queryData) {
                Object.assign(this.query, queryData)
                localStorage.removeItem('queryData')
            }
        }, // End of Component > watch

        /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
        methods: {
            getAging(customer)
            {
                if (customer.createdAt && customer.customerVerificationStatus.idenfoVerificationDate) {
                    let regDate = customer.createdAt
                    let verifictaionDate = customer.customerVerificationStatus.idenfoVerificationDate
                    const start = this.$moment(regDate);
                    const end = this.$moment(verifictaionDate);
                    const diff = end.diff(start, 'days');
                    return diff + " days";
                }

                return null
            },
            getValue(value,closeDate)
            {
                if(value && value!='pending')
                {
                    value = value=='matched'?'Verified':value
                    value = value=='notfound'?'Verified':value
                    value = value=='notmatched'?'Not Verified':value
                    value = value=='found'?'Not Verified':value
                    return value
                }
                if(closeDate && closeDate!=null && (value=='pending' || value=='' || !value))
                {
                    return 'N/A'
                }
                return 'Pending'
            },
            /**
             *
             * @return {void}
             */
            getKeyword(val) {
                this.query.keyword = val
            }, // End of getKeyword() method

            /**
             *
             * @return {void}
             */
            apply() {
                this.$store.commit('setLoading', true)
                this.reset = new Date().getTime()
            }, // End of apply() method

            /**
             *
             * @return {void}
             */
            selectedRecord(record) {
                this.$store.commit('setItem', record)
            }, // End of selectedRecord() method

            /**
             *
             * @return {void}
             */
            sortingChanged(ctx) {
                // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
                this.query.sortBy = ctx.sortBy

                // ctx.sortDesc ==> true if sorting descending, false otherwise
                this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'

                this.apply()
                this.$store.commit('setLoading', false)
            }, // End of sortingChanged() method
            async exportRecords() {
                try {
                    this.query.dataSegmentId = this.dataSegmentId

                    let { data } = await request.post('customers/export-tracker', null, {
                        params: this.query,
                    })

                    // console.log('data  ' + JSON.stringify(data))

                    this.id = data.data.id
                    // this.$bvModal.show('export-process-popup')
                    this.$toasted.show(data.message, {
                        type: 'success',
                    })
                } catch (error) {
                    // console.log(error, 'error')
                }
            }, // End of exportRecords() method

        }, // End of Component > mounted
    } // End of export default
</script>
